






























































































































import { ClaimCategorizationDTO } from "@/model/data.model";
import { ClaimService } from "@/services/ClaimService";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { required } from "vuelidate/lib/validators";
import Modal from "../shared/modal/Modal.vue";

@Component({
  components: {
    MbeModal: Modal
  },
  validations() {
    return {
      categorization: { required },
      description: { required }
    };
  }
})
export default class OpenIncidentModal extends Vue {
  @Prop({ type: String, required: true }) shipmentId: string;

  categorizations: ClaimCategorizationDTO[] = [];
  categorization = "";
  description = "";
  files: File[] = [];
  fileError: string | null = null;

  async loadCategorization() {
    try {
      this.categorizations = await ClaimService.getClaimCategorization();
    } catch (err) {
      console.error(err);
    }
  }

  async created() {
    await this.loadCategorization();
  }

  get disableSaveBtn() {
    return this.$v.$invalid;
  }

  async save() {
    try {
      const res = await ClaimService.openIncident(
        this.shipmentId,
        this.categorization,
        this.description,
        this.files
      );
      console.log("ciao");

      this.$emit("incidentOpened", res);
    } catch (err) {
      console.error(err);
    }
  }

  closeModal() {
    this.$emit("closeModal", false);
  }

  onFilesSelected(e: Event) {
    this.fileError = null;

    const input = e.target as HTMLInputElement;
    const selected = input.files ? Array.from(input.files) : [];

    this.files = [...this.files, ...selected];

    input.value = "";
  }

  openFilePicker() {
    const input = this.$refs.fileInput as HTMLInputElement | undefined;
    if (input) input.click();
  }

  removeFile(idx: number) {
    this.files.splice(idx, 1);
  }
}
